<template>
  <el-dialog
    width="325px"
    class="form-modal"
    :visible="visible"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <div class="player">
      <div class="player__info">
        <div>
          <h3 class="black-text mb-0 mt-0">{{ voicemail.callerName }}</h3>
          <p class="black-text mt-0">
            {{ numberFormatter(voicemail.callerNumber) }}
          </p>
        </div>
        <div>
          <h3 class="black-text mb-0 mt-0">{{ voicemail.vmDay }}</h3>
          <p class="black-text mt-0">{{ voicemail.vmTime }}</p>
        </div>
      </div>

      <audio id="audio-player" controls :src="src" type="audio/wav">
        No support
      </audio>

      <div class="player__metadata">
        <p class="black-text">
          <b>Message Duration: </b> {{ voicemail.duration }}s
        </p>
        <p class="black-text"><b>Transcript: </b>{{ voicemail.transcript }}</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { phoneNumberFormatter } from "@/globals/globals";

export default {
  name: "VoxoMobileVoicemailPlayer",

  props: {
    voicemail: {
      required: true,
    },
    src: {
      required: true,
    },
    visible: {
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit("closeOperation");
    },

    numberFormatter(number) {
      return number ? phoneNumberFormatter(number) : number;
    },
  },
};
</script>

<style lang="scss" scoped>
.player {
  &__info {
    display: flex;
    justify-content: space-between;
  }

  audio {
    width: 100%;
    margin: 10px 0;
  }

  &__metadata {
    text-align: center;
  }
}
</style>
